/**
 * Iter148 — Öffentliche AGB / Terms of Service.
 */
import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-lg font-semibold text-slate-900">Buchhaltung CH</Link>
          <nav className="text-sm space-x-4 text-slate-600">
            <Link to="/privacy" className="hover:text-slate-900">Datenschutz</Link>
            <Link to="/data-deletion" className="hover:text-slate-900">Datenlöschung</Link>
            <Link to="/login" className="text-indigo-600 hover:text-indigo-700">Anmelden</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Allgemeine Geschäftsbedingungen</h1>
        <p className="text-slate-500 mb-8 text-sm">Stand: Juli 2026</p>

        <section className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">1. Vertragsparteien</h2>
            <p>
              Diese AGB regeln das Vertragsverhältnis zwischen dir (nachfolgend &bdquo;Kunde&ldquo;) und
              Buchhaltung CH (nachfolgend &bdquo;wir&ldquo;), bereitgestellt von der Strongfit GmbH mit Sitz in der Schweiz.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">2. Leistungsumfang</h2>
            <p>
              Wir stellen eine cloud-basierte Buchhaltungssoftware für Schweizer KMU zur Verfügung.
              Die Nutzung erfolgt gemäss gewähltem Abo-Modell (Free, Business, Business Pro). Details siehe
              <Link to="/#pricing" className="text-indigo-600"> Preisübersicht</Link>.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">3. Registrierung und Zugang</h2>
            <p>
              Zur Nutzung ist eine Registrierung erforderlich. Du bist verantwortlich für die Geheimhaltung deiner
              Zugangsdaten. Wir behalten uns das Recht vor, Accounts bei Verdacht auf Missbrauch zu sperren.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">4. Zahlungsbedingungen</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Abo-Zahlungen erfolgen monatlich oder jährlich im Voraus via Stripe.</li>
              <li>Preise verstehen sich exkl. MWSt.</li>
              <li>Kündigungen wirken zum Ende der laufenden Abo-Periode. Bereits gezahlte Beträge werden nicht rückerstattet.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">5. Verfügbarkeit</h2>
            <p>
              Wir bemühen uns um eine Uptime von 99.5% im Monatsmittel. Wartungsfenster kündigen wir mindestens 48h
              vorher an. Bei ungeplanten Ausfällen &gt; 4h/Monat gewähren wir eine anteilige Gutschrift auf Anfrage.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">6. Datenexport &amp; Kündigung</h2>
            <p>
              Bei Kündigung kannst du innerhalb von 90 Tagen alle deine Daten als JSON/CSV/PDF exportieren. Danach
              werden die Daten unter Beachtung der 10-jährigen Aufbewahrungspflicht (Art. 958f OR) archiviert und
              nach Ablauf gelöscht (siehe <Link to="/data-deletion" className="text-indigo-600">Datenlöschung</Link>).
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">7. Haftung</h2>
            <p>
              Wir haften nur für vorsätzlich oder grobfahrlässig verursachte Schäden. Die Haftung ist auf den
              12-Monats-Umsatz des Kunden mit uns beschränkt. Wir haften nicht für Steuer- oder Bilanzfehler, die
              durch fehlerhafte Eingaben des Kunden oder KI-Vorschläge entstehen. Die Endkontrolle liegt beim Kunden
              bzw. seinem Treuhänder.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">8. WhatsApp-Bot</h2>
            <p>
              Bei Nutzung des optionalen WhatsApp-Bots gelten zusätzlich die
              <a href="https://www.whatsapp.com/legal/business-terms" target="_blank" rel="noopener noreferrer" className="text-indigo-600"> WhatsApp Business Terms</a>.
              Wir speichern gesendete Belege und Metadaten gemäss <Link to="/privacy" className="text-indigo-600">Datenschutzerklärung §5</Link>.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">9. Änderungen der AGB</h2>
            <p>
              Wir können diese AGB anpassen. Wesentliche Änderungen kündigen wir mindestens 30 Tage im Voraus per
              E-Mail an. Nutzt du unseren Service weiter, gilt deine Zustimmung.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">10. Anwendbares Recht &amp; Gerichtsstand</h2>
            <p>
              Es gilt Schweizer Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist Zürich.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Kontakt</h2>
            <p>Fragen? <a href="mailto:info@ch-buchhaltung.ch" className="text-indigo-600">info@ch-buchhaltung.ch</a></p>
          </div>
        </section>

        <footer className="mt-16 pt-6 border-t border-slate-200 text-sm text-slate-500">
          <p>Buchhaltung CH · Strongfit GmbH</p>
        </footer>
      </main>
    </div>
  );
}
